import './styles/globals.css';
import { setTheme } from '@kk/ui/hooks/useTheme';
import i18n, { initI18n } from '@kk/ui/i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { checkAuthencationStatus, login } from '#/auth';
import { resources } from '#/locales/resources';
import App from './App';

// bootstrap 👞
(async function main() {
  if (import.meta.env.MODE === 'production') {
    const authenticated = await checkAuthencationStatus();
    if (authenticated === false) {
      return login();
    }
  } else {
    await developmentSetup();
  }

  if (!i18n.isInitialized) {
    initI18n({
      lng: 'da',
      resources,
    });
  }

  setTheme('kunde');

  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
})();

async function developmentSetup() {
  try {
    const socket = new WebSocket('ws://localhost:9101');
    socket.addEventListener('message', ({ data }) => {
      const { type, event } = JSON.parse(data) as {
        type: string;
        event: string;
      };
      if (type !== 'custom') return;
      switch (event) {
        case 'factory-reset': // clear cache on factory changes
          // eslint-disable-next-line no-console
          console.log('🏭 database factory reset: reloading page');
          window.requestIdleCallback(() => window.location.reload());
          break;
      }
    });
    socket.addEventListener('error', () => {
      // Silently ignore WebSocket connection errors in development
    });
  } catch (_error) {
    // Silently ignore WebSocket setup errors
  }
}
